import { ChainId } from '@thenexlabs/sdk'
import store from 'state'
import { GAS_PRICE_GWEI } from 'state/user/hooks/helpers'

/**
 * Function to return gasPrice outwith a react component
 */
const getGasPrice = (): string => {
  const chainId = process.env.REACT_APP_PUBLIC_CHAIN_ID
  const state = store.getState()
  const userGas = state.user.gasPrice || GAS_PRICE_GWEI.default
  return chainId === ChainId.AVALANCHE_MAINNET.toString() ? userGas : GAS_PRICE_GWEI.testnet
}

export default getGasPrice
